import React, { useState } from 'react';
import Modal from './index';

const QuestionModal = ({ isOpen, onClose, questions = [], onAnswer }) => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [answer, setAnswer] = useState('');

  // Garantir que questions é sempre um array
  const safeQuestions = Array.isArray(questions) ? questions : [];

  const handleAnswer = async () => {
    if (selectedQuestion && answer) {
      await onAnswer(selectedQuestion.id, answer);
      setAnswer('');
      setSelectedQuestion(null);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Perguntas Pendentes">
      <div style={{ display: 'flex', height: '500px', gap: '20px' }}>
        {/* Lista de Perguntas */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {safeQuestions.map(question => {
            // Acesso seguro aos dados
            const itemTitle = question?.item?.title || 'Item sem título';
            const thumbnailUrl = question?.item?.thumbnail || '';
            const questionText = question?.text || 'Sem pergunta';
            const questionDate = question?.date_created ? 
              new Date(question.date_created).toLocaleString() : 
              'Data não disponível';

            return (
              <div 
                key={question.id || Math.random()}
                onClick={() => setSelectedQuestion(question)}
                style={{
                  padding: '15px',
                  borderBottom: '1px solid #eee',
                  cursor: 'pointer',
                  backgroundColor: 'white',
                  display: 'flex',
                  gap: '15px'
                }}
              >
                {thumbnailUrl && (
                  <img 
                    src={thumbnailUrl}
                    alt={itemTitle}
                    style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'contain',
                      borderRadius: '4px'
                    }}
                  />
                )}
                <div>
                  <h4 style={{ 
                    margin: '0 0 5px 0',
                    fontSize: '0.9rem',
                    color: '#666'
                  }}>
                    {itemTitle}
                  </h4>
                  <p style={{ 
                    margin: '0',
                    fontSize: '1rem',
                    color: '#2D3277'
                  }}>
                    {questionText}
                  </p>
                  <p style={{ 
                    margin: '5px 0 0 0',
                    fontSize: '0.8rem',
                    color: '#999'
                  }}>
                    {questionDate}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Área de Resposta */}
        {selectedQuestion && (
          <div style={{ 
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '15px',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px'
          }}>
            <div style={{ marginBottom: '15px' }}>
              {selectedQuestion.item?.thumbnail && (
                <img 
                  src={selectedQuestion.item.thumbnail}
                  alt={selectedQuestion.item?.title || 'Imagem do produto'}
                  style={{
                    width: '100%',
                    maxHeight: '200px',
                    objectFit: 'contain',
                    marginBottom: '10px'
                  }}
                />
              )}
              <h4 style={{ margin: '0 0 5px 0' }}>
                {selectedQuestion.item?.title || 'Item sem título'}
              </h4>
              <p style={{ 
                margin: '0',
                padding: '10px',
                backgroundColor: '#fff',
                borderRadius: '4px',
                border: '1px solid #eee'
              }}>
                {selectedQuestion.text || 'Sem pergunta'}
              </p>
            </div>
            
            <textarea
  value={answer}
  onChange={(e) => setAnswer(e.target.value)}
  placeholder="Digite sua resposta..."
  style={{
    flex: 1,
    minHeight: '100px', // Altura mínima aumentada
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    resize: 'vertical' // Permite redimensionar verticalmente
  }}
/>
            <button
              onClick={handleAnswer}
              disabled={!answer.trim()}
              style={{
                padding: '10px 20px',
                backgroundColor: answer.trim() ? '#2D3277' : '#ccc',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: answer.trim() ? 'pointer' : 'not-allowed'
              }}
            >
              Enviar Resposta
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default QuestionModal;